export const fmtSlot = (iso, lang) => new Date(iso).toLocaleString(lang === "fr" ? "fr-CA" : "en-CA", {
  weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
});

export const groupByDay = (slots, lang) => {
  const out = [];
  slots.forEach((s) => {
    const raw = new Date(s.start).toLocaleDateString(lang === "fr" ? "fr-CA" : "en-CA", { weekday: "long", month: "long", day: "numeric" });
    const day = raw.charAt(0).toUpperCase() + raw.slice(1);
    const last = out[out.length - 1];
    if (last && last.day === day) last.items.push(s);
    else out.push({ day, items: [s] });
  });
  return out;
};

export const timeOnly = (iso, lang) => new Date(iso).toLocaleTimeString(lang === "fr" ? "fr-CA" : "en-CA", { hour: "numeric", minute: "2-digit" });
